export var CustomRulesSection;
(function (CustomRulesSection) {
    CustomRulesSection["Timing"] = "timing";
    CustomRulesSection["Oraculo"] = "oraculo";
    CustomRulesSection["VisitorProfile"] = "visitorProfile";
    CustomRulesSection["VisitorBehaviour"] = "visitorBehaviour";
    CustomRulesSection["Search"] = "search";
    CustomRulesSection["TravelParty"] = "travelParty";
    CustomRulesSection["DataVariables"] = "dataVariables";
})(CustomRulesSection || (CustomRulesSection = {}));
export var ConditionKind;
(function (ConditionKind) {
    ConditionKind["Exclude"] = "exclude";
    ConditionKind["Include"] = "include";
})(ConditionKind || (ConditionKind = {}));
export var Operator;
(function (Operator) {
    Operator["Any"] = "any";
    Operator["Is"] = "is";
    Operator["Are"] = "are";
    Operator["IsBetween"] = "isBetween";
    Operator["AreBetween"] = "areBetween";
    Operator["IsLower"] = "isLower";
    Operator["AreLower"] = "areLower";
    Operator["IsHigher"] = "isHigher";
    Operator["IsGreater"] = "isGreater";
    Operator["AreGreater"] = "areGreater";
    Operator["IsBefore"] = "isBefore";
    Operator["AreBefore"] = "areBefore";
    Operator["IsAfter"] = "isAfter";
    Operator["AreAfter"] = "areAfter";
    Operator["Contain"] = "contain";
})(Operator || (Operator = {}));
export var DataVariableRuleOperator;
(function (DataVariableRuleOperator) {
    DataVariableRuleOperator["Is"] = "is";
    DataVariableRuleOperator["IsNot"] = "isNot";
    DataVariableRuleOperator["AnyValue"] = "anyValue";
    DataVariableRuleOperator["NotAnyValue"] = "notAnyValue";
    DataVariableRuleOperator["Lower"] = "lower";
    DataVariableRuleOperator["Greater"] = "greater";
    DataVariableRuleOperator["Contains"] = "contains";
    DataVariableRuleOperator["NotContains"] = "notContains";
})(DataVariableRuleOperator || (DataVariableRuleOperator = {}));
export var VisitorStatus;
(function (VisitorStatus) {
    VisitorStatus["Registered"] = "registered";
    VisitorStatus["NonRegistered"] = "non_registered";
})(VisitorStatus || (VisitorStatus = {}));
export var VisitorBehaviourInteractionType;
(function (VisitorBehaviourInteractionType) {
    VisitorBehaviourInteractionType["Any"] = "any";
    VisitorBehaviourInteractionType["First"] = "first";
    VisitorBehaviourInteractionType["All"] = "all";
    VisitorBehaviourInteractionType["Search"] = "search";
    VisitorBehaviourInteractionType["Booked"] = "booked";
    VisitorBehaviourInteractionType["Custom"] = "custom";
})(VisitorBehaviourInteractionType || (VisitorBehaviourInteractionType = {}));
//# sourceMappingURL=rule.types.js.map